module.exports = __webpack_public_path__ + "media/img/event/logo/ellesmere-163161ae365f1cd10105eb5cc229a729.jpg";